import { useState } from 'react';

import { Alert, Button, Paragraph } from '@game/ui';
import type { JSX, MouseEvent, ReactNode } from 'react';

import { LoreTooltip } from '@components/LoreToolTip/LoreToolTip';
import { FirebaseErrors } from '@constants/FirebaseErrors';
import { isFirebaseError } from '@util/isFirebaseError';
import { useAuthContext } from '@hooks/useAuthContext';

import './LoginAnonymously.less';

export const LoginAnonymously = (): JSX.Element => {
  const [loginError, setLoginError] = useState<ReactNode>();
  const { auth } = useAuthContext();
  const errorMessages = FirebaseErrors();

  const onSubmit = async (event: MouseEvent): Promise<void> => {
    event.preventDefault();
    setLoginError(null);

    try {
      await auth.signInAnonymously();
    } catch (error) {
      if (isFirebaseError(error)) {
        const errorMessage = errorMessages[error.code] ?? error.message;
        setLoginError(errorMessage);
      }
    }
  };

  return (
    <div className="login-anonymously">
      <div>
        <Button type="primary" size="large" onClick={onSubmit}>
          Play right now!
        </Button>
        {loginError && <Alert type="error">{loginError}</Alert>}
      </div>
      <Paragraph>
        You will start immediately with a{' '}
        <LoreTooltip
          title="guest account"
          text="A guest account limits account customisation and interactions with other users. Note: resetting the browser will cause account access to be lost."
        />
      </Paragraph>
    </div>
  );
};
